module.exports = __webpack_public_path__ + "img/leader_en_m.f720edad.svg";